import React from 'react';
import { useMemo } from 'react';

export const Pointer = ({ className, left, top, prefixCls, fillStyle }) => {
  return useMemo(() => {
    const pointerStyle = {
      position: 'absolute',
      top,
      left,
    };

    return (
      <div className={`${prefixCls}-pointer ${className || ''}`} style={pointerStyle}>
        <div className={`${prefixCls}-fill`} style={fillStyle} />
      </div>
    );
  }, [left, top, className, prefixCls, fillStyle]);
};
